import $ from "jquery";
import "slick-carousel";
$.noConflict();
$(document).ready(function () {
	$(".testimonial-slider").slick({
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
	});
	$(".success-slider").slick({
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		adaptiveHeight: true,
		responsive: [
			{
			  breakpoint: 768,
			  settings: "unslick",
			},
		  ],
	});
});
